import { TableCell } from '@mui/material';
import { SystemStyleObject } from '@mui/system/styleFunctionSx/styleFunctionSx';
import React from 'react';

import { CustomerCellContent } from '@/components/molecules/CustomerCellContent';
import { CustomerRow } from '@/Screens/Dashboard/Customers/types';

interface Props {
  readonly customer: CustomerRow;
  readonly field: keyof CustomerRow | 'name';
  readonly sx?: SystemStyleObject;
}

export const CustomerTableCell: React.FC<Props> = ({
  customer,
  field,
  sx,
}: Props): React.ReactElement => {
  return (
    <TableCell sx={sx}>
      <CustomerCellContent customer={customer} field={field} />
    </TableCell>
  );
};
